module.exports = __webpack_public_path__ + "img/report_orange.f840f834.svg";